import { Config } from "config/Config"
import { Api } from "./generated/GeneratedAPI"
import { useAuthStore } from "hooks/useAuth"

const INVALID_TOKEN_ERROR_CODE = "INVALID_TOKEN"
// Create a singleton instance of Api with interceptors
const createApi = () => {
  const api = new Api({
    baseURL: Config.isDev ? "http://localhost:3000" : "https://api.loversliveforever.com",
    withCredentials: true
  })

  // Add response interceptor for refresh token
  api.instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config
      if (
        error.response?.data?.errorCode === INVALID_TOKEN_ERROR_CODE &&
        !originalRequest._retry &&
        originalRequest.url !== "/refresh"
      ) {
        originalRequest._retry = true
        try {
          await useAuthStore.getState().refetchAccessToken()
          return api.instance(originalRequest)
        } catch (e) {
          useAuthStore.setState({ isAuthenticated: false })
          throw e
        }
      }
      return Promise.reject(error)
    }
  )

  return api
}

export const apiInstance = createApi()
export const LoversApi = () => apiInstance
